import { useTranslations } from "@acto/web-common/locales";
import { RouteMapPinOutline } from "@acto/web-common/components";
import { NudgeBanner } from "@acto/taskpane/field-sales-2/components/patterns/NudgeBanner";

export function NearbyEntryBanner({ onClick }: { onClick: () => void }) {
  const t = useTranslations("fieldSalesTwo.nearby");
  return <NudgeBanner icon={<RouteMapPinOutline aria-hidden="true" />} label={t("entryLabel")} onClick={onClick} />;
}
